
















import { Component, Prop, Vue } from "vue-property-decorator";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { BButton } from "bootstrap-vue";
import RessifApexBarChart from "../templates/bar-charts/RessifApexBarChart.vue";
import { CharteGraphique } from "@/api/models/options/charteGraphique/charteGraphique";
//@ts-ignore
import { $themeColors } from "@themeConfig";
import { TypeGraphEnum } from "@/api/models/enums/typeGraph";
import { RapportActiviteConfig } from "@/api/models/rapportActivites/rapportActiviteTemplate";

@Component({
  components: {
    SearchableVueSelect,
    BButton,
    RessifApexBarChart,
  },
  name: "bar-consultations-ist-by-tranches-age-chart",
})
export default class BarConsultationsIstByTranchesAgeChart extends Vue {
  @Prop({ required: true }) charteGraphique!: CharteGraphique;
  @Prop({ required: true }) model!: any;
  @Prop({ required: true }) reference!: any;

  title = "Accompagnement individuel";
  description =
    "(034-1) Repartition des consultations IST par tranches d'âge";

  tableFields = [
    { key: "trancheAge", label: "Tranche Age", type: "text", editable: true },
    { key: "nombrePI", label: "Nombre de consultations", type: "number", editable: true },
    { key: "actions", label: "Actions", editable: false },
  ];

  sampleDatas = [
    {
      id: 1,
      trancheAge: "< 25 ans",
      nombrePI: 35
    },
    {
      id: 2,
      trancheAge: ">= 65 ans",
      nombrePI: 55
    },
    {
      id: 3,
      trancheAge: "25 à 34 ans",
      nombrePI: 5
    },
    {
      id: 4,
      trancheAge: "55 à 64 ans",
      nombrePI: 5
    },
  ];

  addLinePayload = {
    trancheAge: "Autres",
    nombrePI: 0,
  };

  seriesArr: any[] | null = null;
  categoriesArr: any[] | null = null;

  typeGraph = TypeGraphEnum.Individuel;
  modelCopy: any | null = null;

  created() {
    this.modelCopy = JSON.parse(JSON.stringify(this.model));
  }

  onRowDeleted(payload: any) {
    this.sampleDatas = this.sampleDatas.filter(x => x.id !== payload.id)
    // Nécessaire car editable-table demande un délai pour l'update
    setTimeout(() => {
      var payloadMapped = this.sampleDatas.map((x: any) => x.nombrePI)
      let dataArray = payloadMapped
      let seriesArray = this.sampleDatas.map((x: any) => x.trancheAge)

      this.seriesArr = [
        {
          key: "Nombre",
          name: "Nombre",
          data: dataArray
        },
      ];
      this.categoriesArr = seriesArray as any[]
    }, 200);
  }

  onRowAdded(payload: any) {
    this.sampleDatas = payload.values

    // Nécessaire car editable-table demande un délai pour l'update
    setTimeout(() => {
      var payloadMapped = this.sampleDatas.map((x: any) => x.nombrePI)
      let dataArray = payloadMapped
      let seriesArray = this.sampleDatas.map((x: any) => x.trancheAge)
      this.seriesArr = [
        {
          key: "Nombre",
          name: "Nombre",
          data: dataArray
        },
      ];      

      this.categoriesArr = seriesArray as any[];

      (this.$refs[payload.graphRef] as any).$refs[payload.graphRef]?.updateOptions(
        {
          xaxis: {
            categories: this.categoriesArr
          }
        }, false, true, true
      )
    }, 200);
  }

  async loadConsultationsISTByTranchesAge(graphRef: any) {
    await this.$http.ressifnet.rapportActivites
      .repartitionConsultationsISTByTranchesAge(this.model)
      .then((response: any) => {
        var responseMapped = response.map((x: any) => x.nombrePI)
        let dataArray = responseMapped

        let seriesArray = response.map((x: any) => x.trancheAge)

        this.seriesArr = [
          {
            key: "Nombre",
            name: "Nombre",
            data: dataArray
          },
        ];

        this.categoriesArr = seriesArray as any[]
        this.sampleDatas = response.map((x: any, index: number) => {
          return {
            id: x.id,
            trancheAge: x.trancheAge,
            nombrePI: x.nombrePI
          }
        });

        (this.$refs[graphRef] as any).$refs[graphRef]?.updateOptions(
          {
            xaxis: {
              categories: this.categoriesArr
            }
          }, false, true, true
        );
        (this.$refs[graphRef] as any).loading = false;
        (this.$refs[graphRef] as any).locked = false;
      }).catch((e: any) => {
        (this.$refs[graphRef] as any).loading = false;
        (this.$refs[graphRef] as any).locked = true;
        (this.$refs[graphRef] as any).disabledButtonTrueData = false;

        let message = e.response?.data?.errors ?
          `Un problème est survenu lors du chargement du graphique: ${Object.values(e.response.data.errors)[0]}` :
          "Un problème est survenu lors du chargement du graphique";

        this.$swal({
          title: 'Erreur',
          text: message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })
      })
  }

  async loadTrueData(graphRef: any, config?: RapportActiviteConfig) {
    await this.loadConsultationsISTByTranchesAge(graphRef);
  }

  toggleExportToList(graphRef: any) {
    this.$emit("toggle-export-to-list", graphRef);
  }

  baseConfig = {
    series: [
      {
        key: "Nombre",
        name: "Nombre",
        data: [25, 35, 25, 15],
      }
    ],
    chartOptions: {
      chart: {
        stacked: false,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: any, opts: any) {
          // Calculer le pourcentage
          let series = opts.w.globals.series[opts.seriesIndex];
          let total = series.reduce((a: any, b: any) => a + b, 0);
          let percentage = ((val / total) * 100).toFixed(1); // Formater à deux décimales

          let percentString = percentage+"%";
          let valueString = "("+val+")";
          
          return [percentString, valueString];
        },
        style: {
          fontSize: '15px'
        }
      },
      legend: {
        show: true,
        position: 'bottom',
        fontSize: '18px',
        width: 550,
        offsetX: 50,
      },
      stroke: {
        show: true,
        colors: ['transparent'],
      },
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      xaxis: {
        categories: this.sampleDatas.map((x: any) => x.trancheAge),
        labels: {
          style: {
            fontSize: '18px'
          },
        }
      },
      yaxis: {
        labels: {
          show: true,
          trim: false,
          style: {
            fontSize: '16px'
          }
        }
        // opposite: isRtl,
      },
      fill: {
        opacity: 1,
      }
    }
  }
}
